import React from "react";
import { CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Field } from "redux-form";
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

//  helpers
import { isRTL } from "../../../../helpers/formatLocale";
import { COMMON_TEXT_COLOR } from "../../../../constants";
import messages from "../../../../locale/jsonMessages";

//  (icons/images)
import imageOne from "/public/siteImages/showAllCars.svg";
import imageTwo from "/public/siteImages/stripImage.svg";

import s from "./StripeCardList.css";

const createOptions = (theme, isRTLLocale) => ({
    style: {
        base: {
            color: COMMON_TEXT_COLOR,
            fontWeight: 400,
            fontFamily: "inherit",
            textAlign: isRTLLocale ? "right" : "left",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            "::placeholder": { color: "#7D7D7D" },
        },
        invalid: {
            color: "#303238",
            "::placeholder": { color: "#7D7D7D" },
        },
    },
});

const StripeCardList = () => {
    const { formatMessage, locale } = useIntl();
    const theme = useSelector(state => state?.currency?.theme);

    return (
        <div className={s.stripCardBox}>
            <div>
                <label><FormattedMessage {...messages.paymentCardNumber} /><sub className='isRequiredStar'>*</sub></label>
                <CardNumberElement
                    options={{
                        placeholder: "4242 4242 4242 4242",
                        ...createOptions(theme, isRTL(locale)),
                    }}
                    className={cx(s.stripCardInputContainer, s.stripCardAccountInput, 'stripCardInputContainerRtl')}
                />
            </div>
            <div className={s.stripCardGridBox}>
                <div>
                    <label><FormattedMessage {...messages.cardExpires} /><sub className='isRequiredStar'>*</sub></label>
                    <CardExpiryElement
                        placeholder="MM / YY"
                        options={{ ...createOptions(theme, isRTL(locale)) }}
                        className={cx(s.stripCardInputContainer, s.stripCardExpiryInput, 'stripCardInputContainerRtl')}
                    />
                </div>
                <div>
                    <label><FormattedMessage {...messages.cvv} /><sub className='isRequiredStar'>*</sub></label>
                    <CardCvcElement
                        placeholder="_ _ _"
                        options={{ ...createOptions(theme, isRTL(locale)) }}
                        className={cx(s.stripCardInputContainer, s.stripCardCvvInput, 'stripCardInputContainerRtl')}
                    />
                </div>
                <div>
                    <label><FormattedMessage {...messages.zipcode} /><sub className='isRequiredStar'>*</sub></label>
                    <div className={cx(s.stripCardInputContainer, s.stripCardOPostalInput, 'stripCardOPostalInputRtl')}>
                        <Field
                            name="zipcode"
                            component="input"
                            type="text"
                            placeholder={formatMessage(messages.zipcode)}
                        />
                    </div>
                </div>
            </div>
            <div className={s.stripCardBottomCaption}>
                <img src={imageOne} alt="list of card" className={s.stripCardBottomCaptionImg} />
                <img src={imageTwo} alt="powered by strip" className={s.stripCardBottomCaptionImg} />
            </div>
        </div>
    );
};

export default withStyles(s)(StripeCardList);
